
// src/connects/google-calendar-page.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import { emitAlertMessage } from '../actions/alert-message'
import moment from 'moment'
import combineHOC from '../helpers/combine-hoc'
import { removeHTML } from '../helpers/google-calendar-html-parse'
import filter from 'lodash/filter'
import AccessToken from '../actions/outlook-access-token'
import { trackPage } from '../helpers/analytics'
const MAX_MONTHS = 1

export const mapStateToProps = (state)=> {
  return {
    isFetching: state.googleApi.isFetching,
    isFetchFailed: state.googleApi.isFetchFailed,
    isCalendarFetchFailed: state.googleApi.isCalendarFetchFailed,
    events: state.googleApi.events,
    calendars: state.googleApi.calendars,
    rightSidePage: state.rightSidePage,
    isOutlookFetching: state.outlookApi.isFetching,
    isOutlookFetchFailed: state.outlookApi.isFetchFailed,
    isOutlookCalendarFetchFailed: state.outlookApi.isCalendarFetchFailed,
    outlookEvents: state.outlookApi.events,
    outlookCalendars: state.outlookApi.calendars,
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    willMount: (props)=> props.updateUI({ date: moment().format('YYYY-MM-DD')}),
    willUnmount: ()=> {
      dispatch(actions.clearGoogleCalendarEvents())
      dispatch(actions.clearGoogleCalendarCalendars())
      dispatch(actions.clearOutlookCalendarEvents())
      dispatch(actions.clearOutlookCalendars())
    },

    willUpdate: (props, nextProps)=> {
      if (!props.isFetchFailed && nextProps.isFetchFailed || !props.isCalendarFetchFailed && nextProps.isCalendarFetchFailed) {
        nextProps.updateUI({ gapiReady: false })
        dispatch(emitAlertMessage({ message: "label:Googleカレンダーの取得に失敗しました" }, 'error'))
      }
      //gapiReadyがtrueになったタイミングで読み出しされる
      if (!props.ui.gapiReady && nextProps.ui.gapiReady) {
        dispatch(actions.fetchGoogleCalendarEvents(nextProps.ui.date, nextProps.ui.calendar))
      }

      if (!props.isOutlookFetchFailed && nextProps.isOutlookFetchFailed || !props.isOutlookCalendarFetchFailed && nextProps.isOutlookCalendarFetchFailed) {
        nextProps.updateUI({ isOutlookReady: false })
        dispatch(emitAlertMessage({ message: "label:Outlookカレンダーの取得に失敗しました" }, 'error'))
      }

      if(!props.outlookCalendars && nextProps.outlookCalendars){
        if(nextProps.outlookCalendars.length > 0){
          //初回のデフォルトカレンダーを設定
          const defaultCalendar = nextProps.outlookCalendars.filter((item) => item.isDefaultCalendar)[0]
          defaultCalendar && nextProps.updateUI({ calendar: defaultCalendar.id })
          dispatch(actions.fetchOutlookCalendarEvents(nextProps.ui.date, defaultCalendar.id))
        } else {
          dispatch(emitAlertMessage({ message: "label:Outlookカレンダーの取得に失敗しました" }, 'error'))
        }
      }
    },

    fetchCalendars: ()=> dispatch(actions.fetchGoogleCalendarCalendars()),

    changeCalendar: (props, calendar)=> {
      //メールアドレスを切り替えた際にeventの中身をclearする
      props.updateUI({ calendar })

      //切り替えた後の今日の日付と予定が表示されるようにする
      let changeCalendarDate = moment().utcOffset(0).format()
      props.ui.gapiReady && dispatch(actions.fetchGoogleCalendarEvents(changeCalendarDate, calendar))
      props.ui.isOutlookReady && dispatch(actions.fetchOutlookCalendarEvents(changeCalendarDate, calendar))
    },

    refreshEvents: (props)=> {
      props.updateUI({ calendar: 'primary' })
      props.ui.gapiReady && dispatch(actions.clearGoogleCalendarEvents())
      props.ui.isOutlookReady && dispatch(actions.clearOutlookCalendarEvents())
    },

    reloadEventsCalendar: (props)=> {
      if (props.isFetching || props.isOutlookFetching)
        return
      let todayDate = moment().utcOffset(0).format()
      props.ui.gapiReady && dispatch(actions.fetchGoogleCalendarEvents(todayDate, props.ui.calendar))
      props.ui.isOutlookReady && dispatch(actions.fetchOutlookCalendarEvents(todayDate, props.ui.calendar))
    },
    
    fetchEvents: (props, date)=> {
      if (props.isFetching)
        return
      let eventDate = moment(date).utcOffset(0).format()
      dispatch(actions.fetchGoogleCalendarEvents(eventDate, props.ui.calendar))
    },

    signInEvents: (props)=> {
      props.updateUI({ gapiReady: true })
      if (props.isFetching)
        return
      props.updateUI({ calendar: props.ui.calendar })
      let todayDate = moment().utcOffset(0).format()
      dispatch(actions.fetchGoogleCalendarEvents(todayDate, props.ui.calendar))
    },

    copyCalendarEvents: (props, date, inDescription, inTime)=> {
      const events = props.ui.gapiReady && props.events || props.outlookEvents
      if(events && events[props.ui.calendar][props.ui.date].length > 0){
        const eventsHTML = `<div><u>${moment(date).format('llll')}</u><br></div>` + 
        filter(events[props.ui.calendar][props.ui.date], (event)=> event.date == date || moment(event.startTime).format('YYYY-MM-DD') != moment(event.endTime).format('YYYY-MM-DD') || event.endDate && event.date <= event.endDate)
          .map((event)=> (
            '<div>'
              //日を跨ぎでかつ時間指定のある予定や終日予定の場合は表示文言を変更する
              + (event.startTime && inTime
                  ? moment(event.startTime).format('YYYY-MM-DD') != moment(event.endTime).format('YYYY-MM-DD')
                    ? `${moment(event.startTime).format('MMMDo(dd) HH:mm')} ~ ${moment(event.endTime).format('MMMDo(dd) HH:mm')}`
                    : `${moment(event.startTime).format('HH:mm')}-${moment(event.endTime).format('HH:mm')}`
                  : event.date && event.endDate && inTime
                    ? '終日'
                    : '')
              + (inTime ? ' ' : '')
              + event.title + `${props.ui.isOutlookReady ? '' : '<br>'}`
              + (inDescription && event.description && `${removeHTML(event.description) + '<br></div>'}` || '</div>')))
          .join('') + '<div><br></div>'
        dispatch(actions.insertDiaryForm(eventsHTML))
      }else {
        dispatch(emitAlertMessage({ message: 'label:予定がないため貼付けできません' }, 'error'))
      }
    },
    loadAccessToken: (microsoftAccess)=> {
      AccessToken.set(microsoftAccess)
    },
    fetchOutlookCalendars: ()=> dispatch(actions.fetchOutlookCalendars()),
    fetchOutlookEvents: (props, date)=> {
      if (props.isOutlookFetching)
        return
      let eventDate = moment(date).utcOffset(0).format()
      dispatch(actions.fetchOutlookCalendarEvents(eventDate, props.ui.calendar))
    },
    changeOutlookCalendar: (props, calendar)=> {
      //メールアドレスを切り替えた際にeventの中身をclearする
      props.updateUI({ calendar })

      //切り替えた後の今日の日付と予定が表示されるようにする
      let changeCalendarDate = moment().utcOffset(0).format()
      dispatch(actions.fetchOutlookCalendarEvents(changeCalendarDate, calendar))
    },
    outlookLogout: () => {
      AccessToken.clear()
      dispatch(actions.clearOutlookCalendarEvents())
      dispatch(actions.clearOutlookCalendars())
    },
    emitAlertMessage: (message)=> dispatch(emitAlertMessage(message, 'error')),
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  ui({ state: {
    calendar: 'primary',
    gapiReady: false,
    isOutlookReady: false,
    checkedDates: [],
    checkedTimeDates: [],
    date: undefined,
  }}),
  lifecycle,
  translate(),
  trackPage('calendar_page'),
)



// WEBPACK FOOTER //
// ./src/connects/google-calendar-page.js